import { ChevronRight, LucideIcon } from "lucide-react";

interface NavigationCardProps {
  icon: LucideIcon;
  title: string;
  onClick?: () => void;
}

export const NavigationCard = ({ icon: Icon, title, onClick }: NavigationCardProps) => {
  return (
    <button className="btn btn-primary" onClick={onClick}>
      <span className="btn-icon-wrap">
        <Icon className="btn-icon" strokeWidth={1.8} />
      </span>
      <span className="btn-text">{title}</span>
      <ChevronRight className="btn-chevron" strokeWidth={2.5} />
    </button>
  );
};
